import type { RestaurantLite } from "../../src/types";

type ServiceDerivable = {
  diningType: string[];
  mealPeriods: ReadonlyArray<{ serviceStyle: string }>;
};

export function deriveService(r: ServiceDerivable): string {
  const dt = r.diningType.map((s) => s.toLowerCase());
  if (dt.includes("character-dining")) return "Character Dining";
  if (dt.includes("buffet")) return "Buffet";
  if (dt.includes("family-style")) return "Family-style";
  if (dt.includes("fine-dining") || dt.includes("signature-dining")) return "Fine Dining";
  if (dt.includes("lounge") || dt.includes("bar")) return "Lounge";
  const allQS =
    r.mealPeriods.length > 0 && r.mealPeriods.every((m) => m.serviceStyle === "Quick Service");
  if (allQS && (dt.includes("snack") || dt.includes("snacks-type"))) return "Snack";
  return r.mealPeriods[0]?.serviceStyle ?? "Quick Service";
}

/** Adapter: lite list carries parallel string array, not full meal-period objects. */
export function deriveServiceFromLite(r: RestaurantLite): string {
  return deriveService({
    diningType: r.diningType,
    mealPeriods: r.mealPeriodServiceStyles.map((serviceStyle) => ({ serviceStyle })),
  });
}
